/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './language-selector.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from './config.service';
import * as import9 from '@angular/common/src/location/location';
import * as import10 from '@angular/router/src/router';
import * as import11 from './utils.service';
import * as import12 from 'angular2-cookie/services/cookies.service';
import * as import13 from '@angular/core/src/metadata/view';
import * as import14 from '@angular/core/src/linker/component_factory';
import * as import15 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import16 from '@angular/common/src/pipes/uppercase_pipe';
import * as import17 from '@angular/core/src/linker/template_ref';
import * as import18 from '@angular/common/src/directives/ng_if';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import22 from '@angular/core/src/linker/element_ref';
import * as import23 from '@angular/common/src/directives/ng_class';
export class Wrapper_LanguageSelectorComponent {
  context:import0.LanguageSelectorComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this.changed = false;
    this.context = new import0.LanguageSelectorComponent(p0,p1,p2,p3,p4);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
  }
  check_resourcePath(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.resourcePath = currValue;
      this._expr_0 = currValue;
    }
  }
  check_currentLanguage(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.currentLanguage = currValue;
      this._expr_1 = currValue;
    }
  }
  check_displayCurrent(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.displayCurrent = currValue;
      this._expr_2 = currValue;
    }
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_3 = currValue;
    }
  }
  check_labels(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this.changed = true;
      this.context.labels = currValue;
      this._expr_4 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_LanguageSelectorComponent_Host:import4.RenderComponentType = (null as any);
class _View_LanguageSelectorComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _LanguageSelectorComponent_0_4:Wrapper_LanguageSelectorComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LanguageSelectorComponent_Host0,renderType_LanguageSelectorComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'div',new import2.InlineArray2(2,'language-selector',''),rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_LanguageSelectorComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LanguageSelectorComponent_0_4 = new Wrapper_LanguageSelectorComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.Location),this.parentInjector.get(import10.Router),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import12.CookieService));
    this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LanguageSelectorComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.LanguageSelectorComponent) && (0 === requestNodeIndex))) { return this._LanguageSelectorComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_LanguageSelectorComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_LanguageSelectorComponent_Host === (null as any))) { (renderType_LanguageSelectorComponent_Host = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_LanguageSelectorComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const LanguageSelectorComponentNgFactory:import14.ComponentFactory<import0.LanguageSelectorComponent> = new import14.ComponentFactory<import0.LanguageSelectorComponent>('[language-selector]',viewFactory_LanguageSelectorComponent_Host0,import0.LanguageSelectorComponent);
const styles_LanguageSelectorComponent:any[] = ([] as any[]);
var renderType_LanguageSelectorComponent:import4.RenderComponentType = (null as any);
class _View_LanguageSelectorComponent0 extends import3.AppView<import0.LanguageSelectorComponent> {
  _text_0:any;
  _anchor_1:any;
  /*private*/ _appEl_1:import5.AppElement;
  _TemplateRef_1_5:any;
  _NgIf_1_6:import15.Wrapper_NgIf;
  _text_2:any;
  _pipe_uppercase_0:import16.UpperCasePipe;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LanguageSelectorComponent0,renderType_LanguageSelectorComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n        ',(null as any));
    this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_1 = new import5.AppElement(1,(null as any),this,this._anchor_1);
    this._TemplateRef_1_5 = new import17.TemplateRef_(this._appEl_1,viewFactory_LanguageSelectorComponent1);
    this._NgIf_1_6 = new import15.Wrapper_NgIf(this._appEl_1.vcRef,this._TemplateRef_1_5);
    this._text_2 = this.renderer.createText(parentRenderNode,'\n        ',(null as any));
    this._pipe_uppercase_0 = new import16.UpperCasePipe();
    this.init(([] as any[]),[
      this._text_0,
      this._anchor_1,
      this._text_2
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (1 === requestNodeIndex))) { return this._TemplateRef_1_5; }
    if (((token === import18.NgIf) && (1 === requestNodeIndex))) { return this._NgIf_1_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = ((this.context.language != this.context.currentLanguage) || this.context.displayCurrent);
    this._NgIf_1_6.check_ngIf(currVal_1_0_0,throwOnChange,false);
    this._NgIf_1_6.detectChangesInInputProps(this,this._anchor_1,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_LanguageSelectorComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.LanguageSelectorComponent> {
  if ((renderType_LanguageSelectorComponent === (null as any))) { (renderType_LanguageSelectorComponent = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,styles_LanguageSelectorComponent,{})); }
  return new _View_LanguageSelectorComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_LanguageSelectorComponent1 extends import3.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import19.Wrapper_NgClass;
  _text_1:any;
  _map_3:any;
  /*private*/ _expr_4:any;
  _pipe_uppercase_0_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_LanguageSelectorComponent1,renderType_LanguageSelectorComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_3 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {active: p0};
    });
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'a',new import2.InlineArray2(2,'class','lgSelect lLink'),(null as any));
    this._NgClass_0_3 = new import19.Wrapper_NgClass(this.parentInjector.get(import20.IterableDiffers),this.parentInjector.get(import21.KeyValueDiffers),new import22.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this._pipe_uppercase_0_0 = import2.pureProxy1((<_View_LanguageSelectorComponent0>this.parent)._pipe_uppercase_0.transform.bind((<_View_LanguageSelectorComponent0>this.parent)._pipe_uppercase_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = 'lgSelect lLink';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_3(((this.parent.context.language === this.parent.context.currentLanguage) || !this.parent.context.displayCurrent));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import2.interpolate(1,'\n                    ',valUnwrapper.unwrap(import2.castByValue(this._pipe_uppercase_0_0,(<_View_LanguageSelectorComponent0>this.parent)._pipe_uppercase_0.transform)((this.parent.context.labels? this.parent.context.labels[this.parent.context.language]: this.parent.context.language))),'\n        ');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.select()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_LanguageSelectorComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_LanguageSelectorComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/language-selector.component.ngfactory.ts